import { render, staticRenderFns } from "./PatrimoineSiteList.vue?vue&type=template&id=47bc8f18&scoped=true&"
import script from "./PatrimoineSiteList.vue?vue&type=script&lang=js&"
export * from "./PatrimoineSiteList.vue?vue&type=script&lang=js&"
import style0 from "./PatrimoineSiteList.vue?vue&type=style&index=0&id=47bc8f18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bc8f18",
  null
  
)

export default component.exports